import i18n from "../i18n";

/**
 * Translation function that can be used outside of React components
 * This function properly handles the i18n typing issues
 *
 * Note: We use 'any' cast here because i18next's TypeScript definitions
 * are not compatible with usage outside of React components
 */
export const t = (key: string, options?: any): string => {
  try {
    // Cast i18n to any to bypass TypeScript's strict typing for the t function
    // This is necessary because i18next's types don't support non-React usage
    const result = (i18n as any).t(key, options);
    return typeof result === "string" ? result : String(result);
  } catch (error) {
    console.warn(`Translation failed for key: ${key}`, error);
    return key;
  }
};
